// Single source of truth for the pre-release "Sentient Mode's outbound
// messaging is off" decision -- imported by the presence cron and the
// hyper-realism API routes (so a locked-out feature can't be reached by
// calling a route directly) and by the UI that would otherwise advertise it.
//
// Why it's off (the owner's call, in this order):
// 1. Image generation isn't ready. Sentient Mode is meant to send images with
//    its messages, and generation is itself locked (MEDIA_GENERATION_LOCKED),
//    so it should launch together with good image gen, not before it.
// 2. There is no real push channel. No service worker, no web-push
//    subscription, no native app -- so a pal's "reaching out" could only ever
//    show as an in-app banner while the person already has the app open, which
//    defeats the point of a pal who checks in when you're away.
// 3. Each message costs tokens.
// The browsing-context tracker that feeds these messages is switched off with
// it, so the app isn't recording page visits for a feature that can't deliver.
//
// Deliberately narrow: this locks only the OUTBOUND part (cron generation,
// banners, the "messaging you outside chat" toggle, page tracking). The
// in-chat presence traits (reliance/attachment, fog, glitches) work fine
// inside a conversation and are untouched.
//
// Flip SENTIENT_MODE_LOCKED back to false once image generation is good and
// there is a real delivery channel -- every locked surface (client and
// server) re-enables together.
export const SENTIENT_MODE_LOCKED: boolean = true
export const SENTIENT_MODE_LOCKED_REASON = "Sentient Mode is switched off for now — coming back soon."
